'use client';

import React, { memo, useCallback, useEffect, useState } from 'react';
import { Example } from '@/types/Example';
import useCreateQuizzQuestion from '@/utils/useCreateQuizzQuestion';
import ShortDescription from './ShortDescription';
import CommandParagraph from './CommandParagraph';
import QuizzAnswerOptions from './QuizzAnswerOptions';
import { useGetSupabaseSession } from '@/hooks/useGetSupabaseSession';
import { trackQuizAnswer } from '@/utils/track-quiz-answer';

interface QuizzQuestionProps {
  unlearnedExamples: Example[];
  answeredExamples: AnswerLogEntry[];
  onAnswer: (
    isCorrect: boolean,
    exampleId: string,
    answerGiven: string,
  ) => void;
  isCommandQuizz: boolean;
}

export interface AnswerLogEntry {
  exampleId: string;
  correct: boolean;
  user_answer: string;
}

const QuizzQuestion = (props: QuizzQuestionProps) => {
  const { unlearnedExamples, answeredExamples, onAnswer, isCommandQuizz } =
    props;
  const [unusableExamples, setUnusableExamples] = useState<Example[]>([]);
  const { exampleToQuizz, rightAnswer, answers, question, isValid } =
    useCreateQuizzQuestion(
      unlearnedExamples,
      answeredExamples,
      unusableExamples,
      isCommandQuizz,
    );
  // TO-DO: Maybe don't create a session each time
  // Maybe move the session to zstore
  const session = useGetSupabaseSession();
  const userId = session?.user?.id;

  useEffect(() => {
    if (isValid === false && exampleToQuizz) {
      setUnusableExamples([...unusableExamples, exampleToQuizz]);
    }
  }, [isValid, exampleToQuizz, unusableExamples]);

  const handleAnswer = useCallback(
    (answerGiven: string) => {
      const { id: exampleId } = exampleToQuizz!;
      const isCorrect = answerGiven === rightAnswer;
      onAnswer(isCorrect, exampleId, answerGiven);
      trackQuizAnswer(exampleId, isCorrect, userId);
    },
    [rightAnswer, onAnswer, exampleToQuizz, userId],
  );

  const content = exampleToQuizz ? (
    <>
      <ShortDescription description={exampleToQuizz.short_description} />
      <CommandParagraph command={question} className="text-center" />
      <QuizzAnswerOptions answers={answers} onAnswer={handleAnswer} />
    </>
  ) : null;

  return content;
  // return (
  //   <Card className="w-full p-6 flex flex-col items-center flex-1">
  //     {content}
  //   </Card>
  // );
};

export default memo(QuizzQuestion);
